import {
  SYSTEM_SETTING_FETCH_REQUEST,
  SYSTEM_SETTING_FETCH_REQUEST_SUCCESS,
  SYSTEM_SETTING_FETCH_REQUEST_FAILURE,
  SYSTEM_SETTING_UPDATE_REQUEST,
  SYSTEM_SETTING_UPDATE_REQUEST_SUCCESS,
  SYSTEM_SETTING_UPDATE_REQUEST_FAILURE,
  SYSTEM_SETTING_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const systemSettingsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SYSTEM_SETTING_FETCH_REQUEST:
    case SYSTEM_SETTING_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SYSTEM_SETTING_FETCH_REQUEST_SUCCESS:
    case SYSTEM_SETTING_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case SYSTEM_SETTING_FETCH_REQUEST_FAILURE:
    case SYSTEM_SETTING_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SYSTEM_SETTING_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default systemSettingsReducer;
